var React = require('react');

function Error24x24 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0h24v24H0V0z","key":0}),React.createElement("path",{"d":"M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

Error24x24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Error24x24;

Error24x24.default = Error24x24;
